import company from 'app/entities/company/company.reducer';
import branchMaster from 'app/entities/branch-master/branch-master.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const entitiesReducers = {
  company,
  branchMaster,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
};

export default entitiesReducers;
